"use client";

import { IQButton } from "@repo/ui/iq-button";
import {
  ContentType,
  ContentTypePluralLabels,
  searchableContentTypes,
} from "../content_types";

type Props = {
  value: ContentType[];
  onChange: (contentTypes: ContentType[]) => void;
};

export function ContentTypesInput({ value, onChange }: Props) {
  return (
    <div className="flex flex-wrap gap-[5px]">
      {searchableContentTypes.map((ct) => {
        const selected = value.includes(ct);
        return (
          <IQButton
            key={ct}
            variant={selected ? "fill" : "outline"}
            color={selected ? "greyLight" : "greyMedium"}
            size="sm"
            onClick={() => {
              if (selected) onChange(value.filter((v) => v !== ct));
              else onChange([...value, ct]);
            }}
          >
            {ContentTypePluralLabels[ct]}
          </IQButton>
        );
      })}
    </div>
  );
}
